import Image from 'next/image';
import React from 'react';

import { useCommonData } from '@app/hooks/useCommonData';
import { cn } from '@app/libs/utils';

interface MobileAppProps {
  className?: string;
}

export const MobileApp: React.FC<MobileAppProps> = ({ className }) => {
  const { website } = useCommonData() as any;
  const mobile = website.mobileApp || {};

  return (
    <section className={cn('w-full flex justify-center', className)}>
      <div className="2xl:w-[90rem] w-full mx-auto px-5">
        <div className="w-full bg-blue-800 rounded-lg p-15 transition-all hover:shadow flex flex-col lg:flex-row items-center gap-10 relative overflow-hidden">
          <div className="flex-1 flex flex-col gap-4 text-center lg:text-left max-w-1/2 lg:max-w-2/3">
            <span className="text-sm font-semibold tracking-wide uppercase text-white/70">
              <Image
                src={mobile.logo || mobile.imageUrl}
                alt="PropX App"
                width={60}
                height={60}
                className="rounded-xl"
              />
            </span>
            <h2 className="text-3xl lg:text-4xl font-medium text-white leading-[1.2]">
              {mobile.title}
            </h2>
            {mobile?.description && (
              <p className="text-white/80 leading-relaxed">{mobile.description}</p>
            )}

            <div className="flex items-center justify-center lg:justify-start gap-20 mt-2 flex-wrap">
              {Object.entries(mobile.stores).map(([key, { url, text }]: any) => (
                <a
                  href={url as string}
                  key={key}
                  className="flex items-center gap-5 rounded-lg px-6 py-2 bg-white cursor-pointer hover:shadow-lg transition-all"
                >
                  <Image
                    src={`/images/${key.toLowerCase()}.svg`}
                    alt={key}
                    width={32}
                    height={32}
                    className="max-w-full max-h-full object-contain"
                  />
                  <span
                    className="text-sm whitespace-pre-line text-primary-800"
                    dangerouslySetInnerHTML={{ __html: text }}
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
